import DialogActionWall from 'pages/components/dialogActionWall';
import About4umText from '../modules/privacy/About4um';

interface IAbout4um {
    openModal: boolean;
    setOpenModal: (event: boolean) => void;
}

const About4um = ({ openModal, setOpenModal }: IAbout4um) => {
    return (
        <DialogActionWall
            open={openModal}
            closeIconButton
            onClose={() => setOpenModal(false)}
            title={''}
            dialogTitleSxProps={{
                textAlign: 'center'
            }}
            dialogActionsSxProps={{
                justifyContent: 'center'
            }}
            dialogPaperSxProps={{
                maxWidth: 600
            }}
        >
            <About4umText/>
        </DialogActionWall >
    );
};

export default About4um;
